
import PageHeader from "./page-header.vue"

import { defineComponent  } from 'vue'

export default defineComponent({
  components: {
    PageHeader,
  },
  props: {
    text: String,
    isShowHeader: {type: Boolean, default: true}
  },
});




